import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import { fetchTempOrders, getError, getIsDataLoaded, getIsPending } from '@/ducks/shopQuotesReducer'

const withShopQuotesLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = true) =>
    // @ts-ignore
    props => (
      // @ts-ignore
      <InitialLoadWrapper
        loadAction={fetchTempOrders}
        loadingSelector={getIsPending}
        loadedSelector={getIsDataLoaded}
        errorSelector={getError}
        forceLoadOnMount={forceLoadOnMount}
      >
        <Component {...props} />
      </InitialLoadWrapper>
    )

export default withShopQuotesLoaded
